var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var disabled = {
    backgroundColor: '#eaeaea',
    color: '#a6a6a6',
    cursor: 'not-allowed',
};
export var focus = {
    boxShadow: "0 0 5px ".concat('#1588af'),
    border: "".concat(1, "px solid ").concat('#1588af'),
};
export var input = __assign(__assign({}, reset), { backgroundColor: '#ffffff', border: '1px solid #cccccc', borderRadius: 2, boxSizing: 'border-box', display: 'block', fontSize: 14, outline: 'none', padding: "".concat(4 + 1, "px ").concat(8, "px ").concat(8 - 1, "px ").concat(8, "px"), position: 'relative', transition: 'box-shadow 0.3s ease-in-out', width: '100%', height: 32, '::placeholder': {
        color: '#a6a6a6',
    }, disabled: disabled, '[disabled]': disabled, ':focus': focus });
export var staticSelect = __assign(__assign({}, input), { appearance: 'none', paddingRight: 36, paddingBottom: 6, '&::-ms-expand': {
        display: 'none',
    } });
export var staticSelectPlaceholder = __assign(__assign({}, staticSelect), { color: '#a6a6a6', option: { color: staticSelect.color } });
export var actions = {
    display: 'block',
    float: 'right',
    fontSize: 0,
    height: 32,
    marginTop: (4 + 2) * -1,
    marginRight: 8 * -1,
    padding: 0,
    pointerEvents: 'none',
    position: 'absolute',
    right: 8,
    top: 6,
    zIndex: 1,
};
export var actionButton = {
    borderLeft: "".concat('1px solid #cccccc'),
    color: '#222222',
    display: 'inline-block',
    fontSize: 'auto',
    height: 32,
    marginLeft: '0px !important',
    marginRight: 0,
    width: 32 - 1,
    ':hover': {
        borderLeft: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
    ':focus': {
        borderLeft: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
};
export var actionButtonDisabled = {
    color: '#a6a6a6',
};
export var staticSelectWrapper = {
    position: 'relative',
    width: '100%',
};
// Loader - Primary
export var loader = {
    display: 'flex',
    lineHeight: 0,
    zIndex: 799,
    margin: '0 5px 0 0',
    minWidth: '25px',
};
export var loadingAnimation = {
    display: 'block',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 'auto',
    margin: 'auto',
    padding: 0,
    height: 8,
    '@keyframes bouncedelay': {
        '0%': {
            transform: 'scale(0)',
        },
        '80%': {
            transform: 'scale(0)',
        },
        '100%': {
            transform: 'scale(0)',
        },
        '40%': {
            transform: 'scale(1)',
        },
    },
};
// Secondary
export var activeSecondary = {
    backgroundColor: '#085a7e',
    borderColor: '#085a7e',
    color: '#ffffff',
};
export var loaderDot = {
    verticalAlign: 'middle',
    width: 8,
    height: 8,
    backgroundColor: '#a6a6a6',
    borderRadius: '100%',
    display: 'inline-block',
    animation: "bouncedelay ".concat(parseFloat('300ms'.replace('ms', '')) * 4, "ms infinite ease-in-out"),
    /* Prevent first frame from flickering when animation starts */
    animationFillMode: 'both',
};
export var loaderDot1 = {
    animationDelay: "-".concat('300ms'),
};
export var loaderDot2 = {
    animationDelay: "-".concat(parseFloat('300ms'.replace('ms', '')) / 2, "ms"),
};
export var dropdownIconContainer = {
    width: '32px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export var listRow = {
    ':hover': {
        backgroundColor: '#e293cf',
        cursor: 'pointer',
    },
};
export var inputBaseActionArea = {
    borderRadius: "".concat(2, "px"),
    maxWidth: '90%',
    height: '30px',
    border: 'none',
    boxSizing: 'border-box',
    margin: '-1px 0 0 -1px',
    padding: '0',
    whiteSpace: 'nowrap',
};
export var inputFullContainerStyles = {
    backgroundColor: '#ffffff',
    border: '1px solid #cccccc',
    borderRadius: "".concat(2, "px"),
    boxSizing: 'border-box',
    fontSize: "".concat(14, "px"),
    outline: 'none',
    transition: 'box-shadow 0.3s ease-in-out',
    width: '100%',
    height: "".concat(32, "px"),
    position: 'relative',
    display: 'flex',
    overflow: 'visible',
};
export var inputContainerBaseStyles = {
    flexGrow: 1,
    display: 'flex',
    verticalAlign: 'top',
    position: 'relative',
    overflow: 'visible',
    border: '1px solid transparent',
    width: '100%',
};
export var inputDropdownFocus = {
    boxShadow: "0 0 5px ".concat('#1588af'),
    borderColor: '#1588af',
    boxSizing: 'border-box',
};
export var inputBaseInputHolder = {
    display: 'flex',
    position: 'relative',
    flexGrow: 1,
    fontWeight: 400,
};
export var inputBaseInputButtonContainer = {
    flex: '0 0 auto',
    width: 'auto',
    maxWidth: 'none',
    border: '1px solid transparent',
};
export var inputBaseLabelStyles = {
    boxSizing: 'content-box',
    position: 'absolute',
    top: 0,
    padding: '6px 0px 0px 8px',
    left: 0,
    width: 'calc(100% - 7px)',
    height: 'fit-content',
    overflow: 'hidden',
    lineHeight: "".concat(16, "px"),
    color: '#a6a6a6',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export var inputBaseClearButton = {
    minWidth: "".concat(32, "px"),
    height: '30px',
    color: '#222222',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '-1px -2px 0 0',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    textDecoration: 'none',
};
export var clearButtonFocusStyles = __assign({}, inputDropdownFocus);
export var inputBaseInputStyles = {
    boxSizing: 'content-box',
    width: '100%',
    background: '0px center',
    border: '0px',
    fontSize: 'inherit',
    fontWeight: 400,
    opacity: 1,
    outline: '0px',
    color: '#222222',
    padding: '4px 0 0 0',
};
export var inputBaseInputWrapper = {
    display: 'flex',
    flexGrow: 1,
    margin: '-4px 0px 0px 8px',
};
export var inputIconBase = {
    boxSizing: 'border-box',
    outline: 'none',
    textDecoration: 'none',
    verticalAlign: 'top',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    color: '#222222',
    display: 'inline-flex',
    height: '30px',
    border: 'none',
    margin: '-1px -1px 0 0',
};
export var inputBaseSeparatorStyles = {
    backgroundColor: '#cccccc',
    width: '1px',
    display: 'inline-flex',
    height: '30px',
    marginTop: '-1px',
};
export var inputBaseMainContainerStyles = {
    position: 'relative',
    width: '100%',
};
export var dropdownListContainer = {
    width: '100%',
    position: 'fixed',
    zIndex: 10,
};
export var inputBaseErrorState = {
    boxShadow: "0 0 0 1px ".concat('#c8102e'),
    border: "1px solid ".concat('#c8102e', " !important"),
};
export var inputBaseDisabledState = {
    backgroundColor: '#eaeaea',
    color: '#a6a6a6',
    cursor: 'not-allowed',
};
export var inputBaseNormalState = {
    backgroundColor: 'white',
    color: '#222222',
    '::placeholder': {
        color: '#a6a6a6',
    },
};
export var inputBasePlaceholderStyles = {
    color: inputBaseNormalState['::placeholder'].color,
};
export var tagContainerStyles = {
    height: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    padding: '0 0 0 8px',
};
export var dropdownListShadowStyles = {
    background: '#ffffff',
    border: '1px solid #dadada',
    borderRadius: "".concat(2, "px"),
    boxShadow: '0 0 3px rgba(0,0,0,.1)',
    boxSizing: 'border-box',
};
export var dropdownListShadowSelectAllStyles = {
// emtpy
};
export var fixedRowListStyles = {
    position: 'absolute',
    left: '0px',
    top: '105px',
    height: '35px',
    width: '100%',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    lineHeight: "".concat(16, "px"),
    background: "".concat('#ffffff'),
    overflow: 'hidden',
    borderTop: "1px solid ".concat('#ffffff'),
    padding: "".concat(8, "px ").concat(32, "px ").concat(8, "px ").concat(12, "px"),
    listStyle: 'none',
    ':hover': {
        background: "".concat('#f5f5f5'),
    },
};
export var disabledStyles = {
    background: "".concat('#eaeaea'),
    color: "".concat('#666666'),
    ':hover': {
        background: "".concat('#eaeaea'),
        cursor: 'not-allowed',
    },
};
export var fixedRowListStylesSelectedHover = {
    background: "".concat('#41a8d2', " !important"),
};
export var fixedRowListStylesSelected = {
    color: "".concat('#ffffff'),
    background: "".concat('#1588af'),
    ':hover': {
        background: "".concat('#41a8d2'),
    },
    '::after': {
        position: 'absolute',
        right: '7px',
        content: '" "',
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/checkmark%3C/title%3E%3Cpath fill='%23FFFFFF' d='M58.237 118.045c.502-.088.969-.369 1.284-.819l67.693-96.675a1.997 1.997 0 0 0-.495-2.777l-3.28-2.296a1.99 1.99 0 0 0-2.778.484l-64.246 91.753L5.628 72.154a2 2 0 0 0-2.785.489l-2.296 3.28c-.638.91-.413 2.15.492 2.784l55.701 39.002c.452.316.989.42 1.492.332z'  fill-rule='evenodd'/%3E%3C/svg%3E\")",
        width: "".concat(16, "px"),
        height: "".concat(16, "px"),
        top: '50%',
        marginTop: '-8px',
    },
};
export var focusedSelectAllRowStyles = {
    background: '#F5F5F5',
};
export var selectAllRowStyles = {
    position: 'unset',
    top: 'unset',
    boxShadow: '0 0 3px rgba(0,0,0,.1)',
    border: '1px solid #dadada',
    borderRadius: '2px',
};
export var focusedRowStyles = {
    background: '#F5F5F5',
};
export var groupedItemStyles = {
    paddingLeft: '24px',
};
export var fixedRowGridStyles = {
    position: 'absolute',
    left: '0px',
    top: '0',
    height: '35px',
    width: '100%',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    lineHeight: "".concat(16, "px"),
    background: "".concat('#ffffff'),
    overflow: 'hidden',
    borderTop: "1px solid ".concat('#ffffff'),
    padding: "".concat(8, "px ").concat(32, "px ").concat(8, "px ").concat(12, "px"),
    listStyle: 'none',
    ':hover': {
        backgroundColor: '#f5f5f5',
        cursor: 'pointer',
    },
};
